import React from 'react';

import useBlueConicPersonalizedReadingHub, {
  type ReadingStatProps,
} from '@hooks/useBlueConicPersonalizedReadingHub';

import CommunityInsights from './CommunityInsights';
import DataTools from './DataTools';
import DeepResearch from './DeepResearch';
import Nav from './Nav';
import Newsletters from './Newsletters';
import OrgCharts from './OrgCharts';
import ReadingStats from './ReadingStats';
import RecommendedArticles from './RecommendedArticles';
import Reporters from './Reporters';
import { SectionRegistryProvider } from './SectionRegistryContext';
import Topics from './Topics';
import { FOR_YOU_COMPONENT_LIST, UserAccess } from './constants';
import type { ForYouContentProps } from './interfaces';

const COMPONENT_MAP: Record<
  string,
  React.ComponentType<ReadingStatProps & Omit<ForYouContentProps, 'headlineVariant'>>
> = {
  CommunityInsights,
  DataTools,
  DeepResearch,
  Nav,
  Newsletters,
  OrgCharts,
  ReadingStats,
  RecommendedArticles,
  Reporters,
  Topics,
};

const ForYouContent = ({
  forumPosts,
  // headlineVariant,
  initialCurrentUser,
  newsletterNames,
}: ForYouContentProps) => {
  const readingStats = useBlueConicPersonalizedReadingHub();

  const userAccess = initialCurrentUser?.is_pro_subscriber ? UserAccess.Pro : UserAccess.Annual;
  const components = FOR_YOU_COMPONENT_LIST[userAccess];
  const additionalProps = {
    forumPosts,
    initialCurrentUser,
    newsletterNames,
  };

  return (
    <SectionRegistryProvider>
      <main className="my-ti-container relative w-full px-16 sm:px-28">
        <div className="mx-auto flex w-full max-w-[1040px] flex-col xl:max-w-container-lg">
          {components.map((name, index) => {
            const Component = COMPONENT_MAP[name];
            if (!Component) return null;
            const props = index === 0 ? { ...additionalProps, hideBorder: false } : additionalProps;

            return <Component key={name} {...props} {...readingStats} />;
          })}
        </div>
      </main>
    </SectionRegistryProvider>
  );
};

export default ForYouContent;
